/* eslint-disable no-param-reassign */
/* eslint-disable no-inner-declarations */
import { SystemFuncArgs } from '@brochington/ecstatic';
import { Components } from 'editor/components';
import MapboxLayer from 'editor/components/map/MapboxLayer';
import MapboxMap from 'editor/components/map/MapboxMap';
import MapboxRasterSource from 'editor/components/map/MapboxRasterSource';
import { ImageSource, RasterLayer, RasterSource } from 'mapbox-gl';

export const manageRasterSourceComponents = [MapboxMap, MapboxRasterSource];

export function manageRasterSource(args: SystemFuncArgs<Components>): void {
  const { entity, components, world } = args;
  const mapComp = components.get(MapboxMap);
  const sourceComp = components.get(MapboxRasterSource);

  if (!mapComp.map || !mapComp.map.loaded()) return;

  const existingRasterSource = mapComp.map.getSource(sourceComp.id);

  const updateMapSourceComponent = () => {
    world
      .grabAll(MapboxLayer)
      .filter(
        ({ component: layerComp }) =>
          (layerComp.tracked.layer as RasterLayer)?.source === sourceComp.id
      )
      .forEach(({ component: layerComp }) => {
        if (mapComp.map?.getLayer(layerComp.tracked.layer.id)) {
          mapComp.map?.removeLayer(layerComp.tracked.layer.id);
          layerComp.added = false;
        }
      });
    mapComp.map?.removeSource(sourceComp.id);
    mapComp.map?.addSource(sourceComp.id, sourceComp.tracked.source);
  };

  if (entity.state === 'destroying') {
    if (sourceComp.added && existingRasterSource) {
      mapComp.map.removeSource(sourceComp.id);
    }

    return;
  }

  if (!sourceComp.added) {
    if (!existingRasterSource) {
      mapComp.map.addSource(sourceComp.id, sourceComp.tracked.source);
    }
    sourceComp.added = true;
  } else if (
    sourceComp.tracked.source &&
    existingRasterSource &&
    sourceComp.tracked.source.type !== existingRasterSource.type
  ) {
    updateMapSourceComponent();
  } else if (
    sourceComp.updatedFields.size > 0 &&
    mapComp.styleState.is('loaded')
  ) {
    const source = mapComp.map.getSource(sourceComp.id) as
      | ImageSource
      | RasterSource;

    if (!sourceComp.tracked.coordinates || !sourceComp.tracked.source) return;

    if (sourceComp.tracked.source.type === 'image') {
      (source as ImageSource).setCoordinates(sourceComp.tracked.coordinates);
      updateMapSourceComponent();
    }

    sourceComp.updatedFields.clear();
  }
}
